import React from 'react';
import { Animated } from 'react-animated-css';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale, LinearScale, PointElement, LineElement,
    Title, Tooltip, Legend, Filler,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const FLAG_LABELS = { week: 'Semana', month: 'Mes', year: 'Año' };

const COLORS = {
    week: { line: '#00C6FE', fill: 'rgba(0,198,254,0.12)', point: '#00C6FE' },
    month: { line: '#6E44FF', fill: 'rgba(110,68,255,0.12)', point: '#6E44FF' },
    year: { line: '#00c97a', fill: 'rgba(0,201,122,0.12)', point: '#00c97a' },
};

class WidgetOccupationGraph extends React.Component {
    state = {
        Flag: 'month',
        loading: false,
    }

    componentWillMount() {
        this.onFetch('month');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.occupancy_graph !== this.props.occupancy_graph) {
            this.setState({ loading: false });
        }
    }

    onFetch = (flag) => {
        const { id } = this.props.params;
        this.setState({ Flag: flag, loading: true });
        this.props.logic_actions && this.props.logic_actions.fetch_occupancy_graph({ IdProperty: id, Flag: flag });
    }

    render() {
        const { occupancy_graph } = this.props;
        const { Flag, loading } = this.state;
        const colors = COLORS[Flag];

        const data = occupancy_graph && occupancy_graph.length ? {
            labels: occupancy_graph.map(d => d.label),
            datasets: [{
                label: '% Ocupación',
                data: occupancy_graph.map(d => d.pct),
                borderColor: colors.line,
                backgroundColor: colors.fill,
                pointBackgroundColor: occupancy_graph.map(d =>
                    d.pct >= 80 ? '#00c97a' : d.pct >= 50 ? '#00C6FE' : '#6E44FF'
                ),
                pointBorderColor: 'transparent',
                pointRadius: occupancy_graph.length <= 12 ? 5 : 3,
                pointHoverRadius: 7,
                borderWidth: 2,
                tension: 0.4,
                fill: true,
            }],
        } : null;

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    backgroundColor: '#1a1a2e',
                    titleColor: '#aaa',
                    bodyColor: '#fff',
                    callbacks: {
                        label: ctx => ` ${ctx.raw}% ocupación`,
                        afterLabel: ctx => {
                            const d = occupancy_graph[ctx.dataIndex];
                            return ` ${d.occupied} / ${d.total} hab.`;
                        },
                    },
                },
            },
            scales: {
                y: {
                    min: 0,
                    max: 100,
                    ticks: { color: '#666', callback: v => `${v}%`, font: { size: 10 } },
                    grid: { color: '#2a2a3a' },
                },
                x: {
                    ticks: { color: '#666', font: { size: 10 } },
                    grid: { color: '#2a2a3a' },
                },
            },
        };

        return (
            <Animated animationIn="fadeInRight" animationInDelay={100} className="w-100 bg-gray-2 px-3 py-3 rounded mt-4">
                <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-chart-line blue font-16 me-2 align-self-center" />
                    <span className="poppins font-14 white align-self-center">Timeline Ocupación</span>
                    {loading && <i className="fas fa-cog fa-spin gray font-12 ms-2 align-self-center" />}
                    <div className="ms-auto d-flex" style={{ gap: 4 }}>
                        {['week', 'month', 'year'].map(f => (
                            <button
                                key={f}
                                onClick={() => this.onFetch(f)}
                                className={`btn btn-sm poppins font-10 px-2 py-1 ${Flag === f ? 'btn-blue white' : 'btn-link gray'}`}
                                style={{ borderRadius: 4 }}
                            >
                                {FLAG_LABELS[f]}
                            </button>
                        ))}
                    </div>
                </div>

                {!data && !loading && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: 160 }}>
                        <span className="gray poppins font-12">Sin datos de ocupación</span>
                    </div>
                )}

                {loading && !data && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: 160 }}>
                        <i className="fas fa-cog fa-spin gray font-20" />
                    </div>
                )}

                {data && (
                    <div style={{ height: 180 }}>
                        <Line data={data} options={options} />
                    </div>
                )}

                {data && (
                    <div className="d-flex mt-2" style={{ gap: 12 }}>
                        <div className="d-flex align-items-center">
                            <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#00c97a', display: 'inline-block', marginRight: 4 }} />
                            <span className="gray poppins font-8">≥80%</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#00C6FE', display: 'inline-block', marginRight: 4 }} />
                            <span className="gray poppins font-8">50–79%</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#6E44FF', display: 'inline-block', marginRight: 4 }} />
                            <span className="gray poppins font-8">&lt;50%</span>
                        </div>
                        <span className="ms-auto gray poppins font-8">
                            {occupancy_graph.length} puntos · {FLAG_LABELS[Flag].toLowerCase()}
                        </span>
                    </div>
                )}
            </Animated>
        );
    }
}

export default WidgetOccupationGraph;
